export interface YuShangState {
  userName?: string;
  userPhone?: string;
  userId?: string | number;
  balance?: string | number;
  activityId?: string | number;
  userInfo?: any;
  activityInfo?: any;
  workType?: string | number;
}

const state: YuShangState = {
  userName: '',
  userPhone: '',
  userId: '',
  balance: '', // 账户余额（C币）
  userInfo: {},
  activityId: '',
  activityInfo: {}, // 活动的基本信息
  workType: 1,
};
const getters = {
  // 用户是否登陆
  isLogin() {
    return !!window.udid && !!window.gettoken() && window.gettoken() !== 'null';
  },
};

const mutations = {
  // 设置用户基本信息
  setUserInfo(state: YuShangState, data: YuShangState) {
    state.userInfo = data;
  },
  // 设置账户余额（C币）
  setBalance(state: YuShangState, val: number) {
    state.balance = val;
  },

  // 设置活动id
  setActivityId(state: YuShangState, val: number) {
    state.activityId = val;
  },

  // 设置用户id
  setUserId(state: YuShangState, val: number) {
    state.userId = val;
  },

  // 设置活动信息
  setActivityInfo(state: YuShangState, data: any) {
    state.activityInfo = data;
  },
  // 设置活动类型
  setWorkType(state: YuShangState, val: number) {
    state.workType = val;
  },
};

const yuShang = {
  namespaced: true,
  state,
  getters,
  mutations,
};

export default yuShang;
